export default __webpack_public_path__ + "static/media/collage.d47589ad.png";